<template>
  <div class="stepper">
    <transition :name="transition" mode="out-in">
      <keep-alive>
        <component :is="steps[step-1]" @next="next" @back="back"/>
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import { ref, computed } from '@vue/composition-api';

export default {
  name: 'WindowStepper',
  props: {
    value: {
      type: Number,
      default: 1,
      validator(val) {
        return val && val > 0;
      }
    },
    steps: {
      type: Array,
      default: () => [],
    }
  },
  setup(props, { emit }) {
    const previousStep = ref(1);

    const transition = ref('');

    const step = computed({
      get() {
        if (props.value >= props.steps.length) {
          return props.steps.length;
        }

        if (props.value <= 1) {
          return 1;
        }

        return props.value;
      },
      set(value) {
        previousStep.value = step.value;
        emit('input', value);
      }
    });


    const back = () => {
      if (step.value === 1) {
        emit('cancel');
      }
      transition.value = 'prev';
      step.value -= 1;
    };

    const next = () => {
      if (step.value === props.steps.length) {
        emit('finish');
      }
      transition.value = 'next';
      step.value += 1;
    };

    return {
      step,
      next,
      back,
      transition,
    };
  },
};
</script>

<style lang="scss" scoped>
.next-enter { opacity: 0; transform: translate(400px, 0); }
.next-enter-active,
.next-leave-active { transition: 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55); }
.next-leave-to { opacity: 0; transform: translate(-400px, 0); }

.prev-enter { opacity: 0; transform: translate(-400px, 0); }
.prev-enter-active,
.prev-leave-active { transition: 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55); }
.prev-leave-to { opacity: 0; transform: translate(400px, 0); }
</style>
